import { render, staticRenderFns } from "./AcceptanceCriteria.vue?vue&type=template&id=53ea3b14&scoped=true&"
import script from "./AcceptanceCriteria.vue?vue&type=script&lang=js&"
export * from "./AcceptanceCriteria.vue?vue&type=script&lang=js&"
import style0 from "./AcceptanceCriteria.vue?vue&type=style&index=0&id=53ea3b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea3b14",
  null
  
)

export default component.exports